<template>
	<div class="staff-boxs">
        <div class="top-bar com-model m-b-15">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/index/finance' }">财务管理</el-breadcrumb-item>
                <el-breadcrumb-item>修改支付密码</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="staffmanage">
            <div class="st-change-bar" style="height:1px;"></div>
            <div class="st-change-item st-change-item2">
                <div class="tit">当前管理员账号</div>
                <div class="name">{{adminInfo.name}}</div>
            </div>
            <div class="st-change-item st-change-item1">
                <div class="tit titrequire">手机号</div>
                <input  type="txt" class="inp"  maxlength="11" v-model="phone" readonly>
                <button class="yzm-btn" :class="{yzmyfs:issend}" @click="getYzm">{{yzmtxt}}</button>
            </div>
            <div class="st-change-item st-change-item1">
                <div class="tit titrequire">验证码</div>
                <input v-model="verifyCode" placeholder="请输入手机验证码" type="text" class="inp" maxlength="6">
            </div>
            <div class="st-change-item st-change-item1">
                <div class="tit titrequire">新密码</div>
                <input v-model="newPayPwd" placeholder="请输入密码" type="password" class="inp">
            </div>
            <div class="st-change-item st-change-item1">
                <div class="tit titrequire">再次输入</div>
                <input v-model="renewPayPwd" type="password" class="inp" placeholder="请再次输入密码">
            </div>
            <div class="stepbtn" @click="gostep">完成</div>
        </div>
    </div>
</template>
<script>
	export default{
		data(){
			return {
				newPayPwd:'',
                renewPayPwd:'',
                verifyCode:'',
                phone:'',
                adminInfo:'',
                issend:false,
                yzmtxt:'发送验证码'
			}
		},
        created(){
                this.getAdmin();
        },
        methods:{
            gostep(){
                if(this.verifyCode.length == 0){
                    this.$message({
                        message: '请填写验证码',
                        type: 'warning'
                    });
                    return;
                }
                if(this.newPayPwd != this.renewPayPwd){
                    this.$message({
                        message: '两次密码输入不一致',
                        type: 'warning'
                    });
                    return;
                }
                let url = `/wapi/company/modifyAccountPayPwd?newPayPwd=${this.newPayPwd}&verifyCode=${this.verifyCode}`;
                this.axios.get(url)
                .then(res => {
                    if(res.status*1 == 200){
                        this.$message({
                            message:'设置成功',
                            type:'success'
                        })
                        setTimeout(()=>{
                            this.$router.back();
                        })
                    }
                })
            },
            getYzm(){
                if(this.issend){
                    return;
                }
                let url = '/wapi/company/getModifyAccountPayPwdCode';
                this.axios.get(url)
                .then(res => {
                    if(res.success){
                        this.issend = true;
                        this.yzmDjs();
                    }
                })
            },
            yzmDjs(){
                let times = 60;
                this.yzmtxt = times + 's后重新发送';
                let interval = setInterval(()=>{
                    times--;
                    if(times < 0){
                        clearInterval(interval);
                        this.yzmtxt = "发送验证码"
                        this.issend = false;
                    }else{
                        this.yzmtxt = times + 's后重新发送';
                    }
                },1000);
            },
            getAdmin(){
                let url = `/wapi/company/getAdmin`;
                this.axios.get(url).then(res => {
                    this.adminInfo = res.data;
                    this.phone = res.data.phone;
                })
            }
        }
	}


</script>
<style scoped lang="less">
@import url('../../assets/less/base.less');
	@import "../../assets/css/variable";
    @import "../../assets/css/staff";
.com-model, .staffmanage {
    border-radius: 10px;
}
.top-bar {
    padding: 22px 24px;
    line-height: 30px;
}
    .staffmanage .st-change-item .yzmyfs{
        background: #ccc;
        border-color: #ccc;
        cursor: not-allowed;
    }
</style>



// WEBPACK FOOTER //
// modifyPayPassword.vue?081a54f4